export function ActionFromCMS(action) {
    try {
        (function () { eval(action); }());
    }
    catch (e) {
        console.error(e);
    }
}
//# sourceMappingURL=ActionFromCMS.js.map